/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import { makeStyles } from '@griffel/react';

/**
 * Styles for the Footer slots
 */
export const useFooterStyles = makeStyles({
  root: {},
  socialLink: {
    width: '32px',
    height: '32px',
    display: 'block',
    lineHeigh: '1.2',
    color: 'inherit'
  }
});
